import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { SupplierChecklist, CtaBand } from "@/components/site/Sections";
import { IMAGES } from "@/components/site/data";

export default function Suppliers() {
  return (
    <>
      <PageHero overline="Supplier Partnerships" title="Building Long-Term International Relationships." image={IMAGES.warehouse}>
        <p>
          RSC Imports works with manufacturers, producers and brands seeking sustainable expansion
          into high-growth international markets.
        </p>
        <p>
          Our procurement team assesses opportunities on both product quality and long-term
          commercial potential.
        </p>
      </PageHero>

      <section className="pt-20 md:pt-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <p className="text-xs md:text-sm uppercase tracking-[0.25em] font-semibold text-[#BFA26F] mb-4" data-testid="overline-supplier-requirements">
              Supplier Requirements
            </p>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-medium leading-tight text-[#111413] max-w-3xl">
              What We Look For in Our Supplier Network.
            </h2>
            <div className="mt-6 h-px w-24 bg-[#BFA26F]" />
          </Reveal>
        </div>
      </section>

      <SupplierChecklist showHeader={false} />

      <div className="pb-24 md:pb-32" />

      <CtaBand
        title="Introduce Your Company."
        text="RSC Imports seeks to establish sustainable relationships with manufacturers and producers capable of supporting international growth."
        buttonLabel="Submit Your Products"
        to="/partner"
      />
    </>
  );
}
